import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_PRODUCT_DETAILS: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetProductDetails'
);

export const SET_PRODUCT_ACTIVITY_FEED: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetProductActivityFeed'
);

export const SET_CUSTOMER_NAME: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetCustomerName'
);

export const ADD_BOOK_VIEWING: string = typeCreatorV2(
  'ProductDetailsReducer',
  'AddBookViewing'
);

export const ADD_REQUEST_INFO: string = typeCreatorV2(
  'ProductDetailsReducer',
  'AddRequestInfo'
);

export const SET_SIMILAR_PRODUCTS: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetSimilarProducts'
);
export const SET_EXISTING_BOOKVIEWING: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetExistingBookviewing'
);
export const SET_EXISTING_REQUESTINFO: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetExistingRequestInfo'
);
export const CANCEL_APPOINTMENT: string = typeCreatorV2(
  'ProductDetailsReducer',
  'CancelAppointment'
);

export const ADD_TO_FAVOURITE: string = typeCreatorV2(
  'ProductReducer',
  'AddToFavourite'
);

export const REMOVE_FROM_FAVOURITE: string = typeCreatorV2(
  'ProductReducer',
  'RemoveFromFavourite'
);

export const CHATGROUP_DETAILS: string = typeCreatorV2(
  'ProductDetailsReducer',
  'ChatgroupDetails'
);

export const SET_SHARING_PRODUCT: string = typeCreatorV2(
  'ProductDetailsReducer',
  'ShareProduct'
);

export const RESET: string = typeCreatorV2('ProductDetailsReducer', 'Reset');
export const SET_LIST_VIEWED: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetListViewed'
);

export const ADD_FAVOURITE: string = typeCreatorV2(
  'ProductDetailsReducer',
  'AddFavourite'
);

export const SET_CLIENT_COLLECTION_PERSONAL: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetClientCollection'
);

export const SET_ADD_SHARING_PRODUCT: string = typeCreatorV2(
  'ProductDetailsReducer',
  'AddSharingProduct'
);

export const SET_ADD_COLLECTIONS: string = typeCreatorV2(
  'ProductDetailsReducer',
  'AddCollection'
);

export const DELETE_COLLECTION: string = typeCreatorV2(
  'ProductDetailsReducer',
  'DeleteCollection'
);

export const SET_TOPIC_LIST: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetTopicList'
);

export const SUBSCRIBE_TO_NEWS_LETTER: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SubscribeToNewsLetter'
);
export const SET_TOPIC_LIST_BY_CATEGORY: string = typeCreatorV2(
  'ProductDetailsReducer',
  'SetTopicListByCategory'
);
